import { useState } from "react";
import JoinModal from "./button"; // ⬅️ if the file is named Button.js, use "./Button"

export default function About() {
  const [open, setOpen] = useState(false);

  const dividerStyle = {
    width: "100%",
    height: "1px",
    background: "rgba(162, 199, 233, 0.7)", // soft blue divider
    boxShadow: "0 0 18px rgba(162, 199, 233, 0.7)",
    margin: "4rem 0 3rem",
  };

  return (
    <>
      {/* 🔹 Top divider – separates from Activity Slider */}
      <div style={dividerStyle} />

      <section
        id="about"
        style={{
          lineHeight: "1.9",
          fontSize: "1.2rem",
          color: "#1f2e36",
          whiteSpace: "pre-line",
          paddingBottom: "3rem",
        }}
      >
        <h3
          style={{
            color: "rgb(0, 0, 0)",
            marginBottom: "1.5rem",
            textAlign: "center",
            fontSize: "1.6rem",
          }}
        >
          About Us
        </h3>

        {/* ⭐ FULL-WIDTH ABOUT BOX ⭐ */}
        <div
          style={{
            width: "100%",
            background: "var(--panel)",
            border: "1px solid var(--hairline)",
            borderRadius: "18px",
            padding: "3rem 2rem",
            boxSizing: "border-box",
            color: "var(--ink-muted)",
            minHeight: "350px",
          }}
        >
          {/* Constrain text inside so it doesn't stretch too wide */}
          <div
            style={{
              maxWidth: "900px",
              margin: "0 auto",
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
              fontSize: "1.1rem"
            }}
          >
            <div>
              At BeFitFriends, our mission is simple — to connect people through
              fitness. We believe that finding someone who shares your energy and
              passion makes staying active easier, and more fun! <br />
              <br />
              Whether you love running at sunrise, lifting at the gym, or exploring
              new activities, BeFitFriends helps you match with others who share your
              interests and goals, making every workout a chance to meet new friends,
              stay motivated, and grow stronger together.
            </div>

            <div
              style={{
                textAlign: "center",
                fontWeight: "900",
                fontSize: "1.8rem",
                marginTop: "1rem",
                color: "#000000ff",
              }}
            >
              Want to download on Android?
            </div>

            <div
              style={{
                textAlign: "center",
                fontWeight: "500",
                fontSize: "1.1rem",
                maxWidth: "700px",
                marginLeft: "auto",
                marginRight: "auto",
                lineHeight: "1.5",
                color: "rgb(0, 0, 0)",
              }}
            >
              Sign up for the waitlist below and we’ll notify you when it’s ready!
          
            </div>


            {/* 🔹 Button that OPENS the JoinModal */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                type="button"
                onClick={() => setOpen(true)}
                style={{
                  background: "#a2c7e9ff",
                  color: "#000",
                  display: "inline-block",
                  padding: "1rem 2rem",
                  borderRadius: "12px",
                  fontWeight: 600,
                  border: "none",
                  cursor: "pointer",
                  fontSize: "1.05rem",
                }}
              >
                Sign Up for the Android Waitlist!
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 🔹 Bottom divider – separates About from next section */}
      <div style={dividerStyle} />

      {/* 🔹 Join modal wired up */}
      <JoinModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
